"use client";

import { ReactNode, useState } from "react";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

export default function FaqSection() {
  return (
    <div className="section c1 gap20">
      <div className="title">Questions fréquentes</div>
      <div className="c1 gap20">
        <ExpansionTile
          title="Ai-je besoin d'une connexion internet ?"
          isInitalyExpanded={true}
        >
          Non, la plateforme REMED fonctionne entièrement hors ligne. Vous avez
          cependant besoin d&apos;une connexion internet si vous décidez
          d&apos;envoyer des notifications automatiques par SMS ou de garder une
          sauvegarde sécurisée au niveau du cloud.
        </ExpansionTile>
        <ExpansionTile
          title="Puis-je créer un compte pour mon/ma secrétaire ?"
          isInitalyExpanded={true}
        >
          Oui, vous pouvez créer un compte pour votre secrétaire et travailler
          en collaboration en temps réel en réseau local
        </ExpansionTile>
        <ExpansionTile
          title="Je travaille dans un cabinet de groupe, y a t'il une limite pour le nombre de comptes ?"
          isInitalyExpanded={true}
        >
          Non, il n&apos;y a pas de limite pour le nombre de comptes. Vous
          pouvez ajouter autant de comptes que vous le souhaitez.
        </ExpansionTile>
      </div>
    </div>
  );
}

export function ExpansionTile({
  title,
  children,
  isInitalyExpanded,
}: {
  title: ReactNode;
  children: ReactNode;
  isInitalyExpanded: boolean;
}) {
  let [isExpanded, setIsExpanded] = useState(isInitalyExpanded || false);

  return (
    <div
      onClick={async () => {
        setIsExpanded(!isExpanded);
      }}
      className={` expansionTile ${isExpanded ? "expanded" : ""} p10`}
    >
      <div
        className="expansionTileHeader"
        style={{ gridTemplateColumns: " 1fr auto" }}
      >
        <div className="bold">{title}</div>
        {isExpanded ? <IoChevronUp /> : <IoChevronDown />}
      </div>
      <div className="expansionTileContent">
        <div className="grid c1 gap10 p10 ">{children}</div>
      </div>
    </div>
  );
}
